
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form22";
const form22State = namespace("Form22");

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import Form22 from "@/components/process/Form22/components/pdf/Form22.vue"

import { form22StatusInfoType } from '@/types/Information/Form22';

@Component({
    components:{
        Form22ProcessHeader,
        Form22
    }
})
export default class PreviewForm22 extends Vue {

    @form22State.State
    public currentNoFeesPayableId: string;

    stepsCompleted = {} as form22StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form22"}); 
    }
}
